import { getProductPageTabFromHash } from './shared';

const idFromQuery = (query = {}, identifiers = []) => {
  const id = identifiers.find(identifier => query[identifier]);
  return query[id];
};

// eslint-disable-next-line no-bitwise
const is32BitInt = x => (x | 0) === x;

function getProductPageTabFromQuery(query, id) {
  if (parseInt(query.e, 10) === id) {
    return 'properties';
  }

  if (parseInt(query.o, 10) === id) {
    return 'reviews';
  }

  if (parseInt(query.pu, 10) === id) {
    return 'statistics';
  }

  return 'main';
}

const matchClassicRoute = (
  pathname,
  query = {},
  hash = '',
  useHashForProductTabs = false
) => {
  switch (pathname.split('/')[1]) {
    case 'product.php':
    case 'produkt.php': {
      // The following pages does not exist anymore and should be permanently redirected
      const redirectQueryParams = [
        'cc',
        'em',
        'g',
        'map',
        'pid',
        'r',
        'rec',
        'rel',
      ];
      if (redirectQueryParams.some(key => query[key] !== undefined)) {
        return undefined;
      }

      // Bastardised version of the price history URL, e.g. /product.php/statistics?p=1234
      // This should be redirected, so not matched here.
      if (/statistics$/.test(pathname)) {
        return undefined;
      }

      let route = 'product';

      if ('create_alert' in query || /bevaka|alert$/.test(pathname)) {
        route = 'productAlert';
      }

      const id = parseInt(
        idFromQuery(query, [
          'p',
          'e',
          'rec',
          'o',
          'pu',
          'g',
          'rel',
          'em',
          'map',
          'r',
          'pid',
          'cc',
        ]),
        10
      );

      if (!is32BitInt(id)) {
        return undefined;
      }

      // Render 404 on missing id
      if (!id) {
        return undefined;
      }

      // Early return for non-product route as we don't need a section
      if (route === 'productAlert') {
        return {
          route,
          params: {
            id,
          },
        };
      }

      const section = useHashForProductTabs
        ? getProductPageTabFromHash(hash)
        : getProductPageTabFromQuery(query, id);

      // If using hash for product tabs, we want to redirect the query variant to that,
      // so not matched here.
      if (
        useHashForProductTabs &&
        getProductPageTabFromQuery(query, id) !== 'main'
      ) {
        return undefined;
      }

      return {
        route,
        params: {
          id,
          section,
        },
      };
    }
    case 'kategori.php':
    case 'category.php': {
      let id = idFromQuery(query, ['k', 'c', 'l', 'm', 'b', 'lb']);
      let filterId;

      if (id === 'all') {
        return undefined;
      }

      if (id === 'v1004') {
        return {
          route: 'services',
          params: {},
        };
      }

      if (/^s/.test(id) && query.catId) {
        filterId = id;
        id = query.catId;
      }

      // No category id exists and we don't have a category index page
      // Load 404 route instead
      if (!id && !filterId) {
        return undefined;
      }

      // Make sure id is in correct format
      if (!/^(s|v)?\d+$/.test(id)) {
        return undefined;
      }

      return {
        route: 'category',
        params: {
          id,
          filterId,
          ...(query.t && parseInt(query.t, 10) > 0 ? { brand: query.t } : {}),
        },
      };
    }
    case 'butiksinfo.php':
    case 'shop.php':
    case 'store.php': {
      const id = parseInt(idFromQuery(query, ['f', 'ftgid']), 10);

      const section =
        typeof query.f === 'string' ? query.f.split('/')[1] : undefined;

      // Render 404 on missing id
      if (!id) {
        return undefined;
      }

      return {
        route: 'store',
        params: {
          id,
          section,
        },
      };
    }
    case 'brand.php':
    case 'tillverkare.php': {
      const id = parseInt(idFromQuery(query, ['t']), 10);

      // Render 404 on missing id
      if (!id) {
        return undefined;
      }

      return {
        route: 'brand',
        params: {
          id,
        },
      };
    }
    default:
      return undefined;
  }
};

export default matchClassicRoute;
